import { Component, input, OnInit, signal } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'app-ui-alert-information',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-information.component.html',
  styleUrls: ['./alert-information.component.scss'],
})
export class AlertInformationComponent implements OnInit {
  alertType = input<'warning' | 'success' | 'info'>('warning');
  iconType = input<'normal' | 'small'>('normal');
  message = input.required<string>();
  img = signal<string>('');

  ngOnInit() {
    const assets = '../assets/lib/icons/alerts';
    this.img.set(`${assets}/${this.alertType()}.svg`);
  }
}

// TODO: CRIAR ENUM PARA ALERT TYPE
